import React, { useState, useEffect } from 'react';
import Loader from '../Common/Loader';
import { getFormattedNumber, roundToTwo } from '../utils/textUtils';
import { stockReport } from '../../services';
import { Modal } from 'antd';
import { stockTransferItemReport } from '../../services/Purchase/Reports';

const StockTransferReports = ({ resPacket, loading, warehouse }) => {

    return (
        <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr>
                        <td>BATCH NO.</td>
                        <td>STN NO.</td>
                        <td>MFG DATE</td>
                        <td>EXPIRY DATE</td>
                        <td>ITEM TITLE</td>
                        <td className='text-center'>QTY</td>
                        <td className='text-center'>STORE</td>
                        <td className='text-center'>CELL</td>
                        <td className='text-center'>RACK</td>
                        <td className='text-center'>PALLETE</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {resPacket?.data?.map((row, i) => {
                        if (row.isMultipleBatchDetails) {
                            let batchMultipleDetails = [];
                            let stn = "";
                            let itemTitle = ""
                            let mfgDate = "";
                            let expDate = ""
                            try {
                                batchMultipleDetails = JSON.parse(row.batchMultipleDetails);
                                stn = row.stockTransferNo;
                                itemTitle = row.itemTitle
                                expDate = row.batchExpiredDate;
                                mfgDate = row.batchManufacturingDate;

                            } catch (error) {
                                console.error("Error parsing batchMultipleDetails:", error);
                            }
                            return batchMultipleDetails.map((subRow, j) => (
                                <tr key={j}>
                                    <td>{subRow.batchNumber}</td>
                                    <td>{stn}</td>
                                    <td>{subRow?.batchManufacturingDate}</td>
                                    <td>{subRow?.batchExpiredDate}</td>
                                    <td>{itemTitle}</td>
                                    <td className='text-right'>{subRow?.batchQuantitySelected}</td>
                                    <td className='text-right'>{subRow.storeTitle}</td>
                                    <td className='text-right'>{subRow.cellTitle}</td>
                                    <td className='text-right'>{subRow.rackTitle}</td>
                                    <td className='text-right'>{subRow.palletTitle}</td>
                                </tr>
                            ));
                        } else {
                            return (
                                <tr key={i}>
                                    <td>{row.batchNumber}</td>
                                    <td>{row.stockTransferNo}</td>
                                    <td>{row.batchManufacturingDate}</td>
                                    <td>{row.batchExpiredDate}</td>
                                    <td>{row.itemTitle}</td>
                                    <td className='text-right'>{row?.batchQuantity}</td>
                                    <td className='text-right'>{row.storeTitle}</td>
                                    <td className='text-right'>{row.cellTitle}</td>
                                    <td className='text-right'>{row.rackTitle}</td>
                                    <td className='text-right'>{row.palletTitle}</td>
                                </tr>
                            );
                        }
                    })}
                </tbody>
            </table>
        </div>
    );
};


export default StockTransferReports;
